export const NG_UI_STORAGE_KEY_PREFIX = 'lvflanders.bar.ng.ui.';
